import { useTranslation } from 'react-i18next'
import { Block, CRIcon, CRRender, Inline } from '../../crRender'
import './style.css'
import useFileUpload from './hooks/useFileUpload'

const FileUpload = ({ accept, value, setValue, label, isRequired = false, multiple = false, className = "" }) => {
    const { t } = useTranslation()
    const { isDragging, dropZoneRef, inputRef,
        getFileIcon, formatFileSize, handleDragEnter,
        handleDragLeave, handleDrop, handleInputChange,
        handleRemove, stopDefaultEvent } = useFileUpload(value, setValue, multiple)


    return (
        <div className={`file-upload-container  ${className}`}>
            <CRRender isRender={!!label}>
                <label className="file-upload-label">
                    {t(label)}
                    <Inline isRender={isRequired} className="required">*</Inline>
                </label>
            </CRRender>

            <div
                ref={dropZoneRef}
                className={`file-upload-dropzone pointer ${isDragging ? 'dragging' : ''} ${!value?.isEmpty() ? 'has-file' : ''}`}
                onDragEnter={handleDragEnter}
                onDragOver={stopDefaultEvent}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => inputRef.current?.click()}
            >
                <input
                    ref={inputRef}
                    type="file"
                    accept={accept}
                    multiple={multiple}
                    onChange={handleInputChange}
                    className="file-upload-input"
                />

                <div className="file-upload-placeholder">
                    <CRIcon icon={getFileIcon()} className="upload-icon" />
                    <div className="upload-text">
                        <span className="upload-text-main">{t("drag-drop-files")}</span>
                        <span className="upload-text-sub">{t(`supported-formats-${accept|| 'pdf'}`)}</span>
                    </div>
                </div>
            </div>
            <Block isRender={!value?.isEmpty()} className="file-upload-preview-container">
                    {value?.map((item, index) =>
                        <div key={index} className="file-upload-preview">
                            <div className="file-icon-wrapper">
                                <CRIcon icon={getFileIcon(item?.name)} className="file-icon" />
                            </div>
                            <div className="file-info">
                                <div className="file-name">{item?.name?.length > 20 ? item?.name?.substring(0, 20) + '...' : item?.name}</div>
                                <Block isRender={!!item?.size} className="file-size">{formatFileSize(item.size)}</Block>
                            </div>
                            <button type="button" className="file-remove-btn"
                                onClick={(e) => handleRemove(e, index)} title={t("remove")}  >
                                <CRIcon icon="mdi:close-circle" />
                            </button>
                        </div>
                    )}
                </Block>
        </div>
    )
}

export default FileUpload

